import React, { Component, Fragment, useState, useEffect, cloneElement } from 'react'
import LogoFPJ from '../../Assets/Logo/LogoFPJ.png'
import { 
    MenuOutlined,
    CloseOutlined,
    LocationOnOutlined,
    ReportProblemSharp,
    AccountCircleOutlined,
    GroupAddOutlined
    } from '@material-ui/icons'
import {Prompt, useHistory, Link} from 'react-router-dom'
    
import  '../../Css/SideDrawer_Template.scss'
import {LogoutController} from '../../Controller'


 

const SideDrawer = (props) =>{
    const [NavClassname, setNavClassname] = useState("navWrapper")
    const [SideDrawwer, setSideDrawwer] = useState(false)
    const [ShowChildMenu, setShowChildMenu] = useState({
        UpdateProfile:false
    })
    const history = useHistory()


    useEffect(()=>{
        if(props.home){
            window.addEventListener('scroll', function(){
                window.scrollY == 0 ? setNavClassname("navWrapper") : setNavClassname("navWrapper navWrapperBacground")
            })
        }
        else{
            setNavClassname("navWrapper navWrapperBacground")
        }
    },[])

    

    const showSideDrawwer = () => {
        setSideDrawwer(true)
    }
    
    const hideSideDrawwer = () =>{
        setSideDrawwer(false)
    }

    const handleLogout = () =>{
        LogoutController().then(()=>{
            history.push('/')
        })
    }

    const BackToHome = () => {
        history.push("/Home")
    }

    const HandleChildMenu = (e) => {
        e.preventDefault()
        const {name} = e.target
        setShowChildMenu(prev=>({
            ...prev,
            [name]: ShowChildMenu[name] == false ?true:false
        }))
        console.log(ShowChildMenu)
    }
    
    const ChildMenu = (props) => {
        return (
            <div>
                <Link to ={props.link}>
                    {props.Menuname}
                </Link>
            </div>
        )
    }
    return(
        
        <Fragment>
            <section className= {SideDrawwer == false ? "sideMenuContainer" :"sideMenuContainer sideMenuDrawerShow"}>
                <div className = "sideMenuHeader">
                   <div className="wrap">
                        <div className="nextMeet">
                            <LocationOnOutlined/>
                            NextMeet - Ragunan Jakarta
                        </div>
                        <div className="closedIcon"  onClick = {hideSideDrawwer}>
                            <CloseOutlined />
                        </div>
                   </div>
                </div>
                <div className="sideMenuBody">
                        <div className="categoryMenuWrapper">
                            <p>Projects</p>
                            <ul>
                                <li>
                                      <Link className = "MenuParent" to ><CloseOutlined/> Sample Menu</Link>
                                </li>
                                <li>
                                      <Link className = "MenuParent" to ><CloseOutlined/> Sample Menu</Link>
                                </li>
                                <li> 
                                      <Link className = "MenuParent" to ><CloseOutlined/> Sample Menu</Link>
                                </li>
                            </ul>
                        </div>
                        <div className="categoryMenuWrapper">
                            <p>Settings</p>
                            <ul>
                                <li>
                                      <Link className = "MenuParent" to  name="UpdateProfile" onClick={e=>HandleChildMenu(e)}> <GroupAddOutlined/> Update Profile </Link>

                                      <div className = {ShowChildMenu.UpdateProfile ? "MenuParentWrapper_show" : "MenuParentWrapper" }   >
                                            {childUpdateProfileMenu.map((key,idx) =>
                                                <ChildMenu
                                                    
                                                    Menuname={key.Menuname}
                                                    link = {key.link}
                                                    idx = {idx}
                                                />
                                            )}
                                      </div>
                                </li>
                                <li>
                                    <Link className = "MenuParent" to ><AccountCircleOutlined/> Show Profile</Link>
                                </li>
                            </ul>
                        </div>
                        <div className="categoryMenuWrapper">
                            <p>Notifications</p>
                            <ul>
                                <li>
                                    <Link className = "MenuParent" to ><CloseOutlined/> Sample Menu</Link>   
                                </li>
                                <li>
                                    <Link className = "MenuParent" to ><CloseOutlined/> Sample Menu</Link>
                                </li>
                                <li>
                                    <Link className = "MenuParent" to ><CloseOutlined/> Sample Menu</Link>
                                </li>
                            </ul>
                        </div>
                     
                    
                    

                </div>
                <div className="sideMenuFooter">
                   <div>
                        <a href="#" onClick={handleLogout}>Logout</a>
                   </div>
                </div>
            </section>

            <div className = 
                {SideDrawwer == false ? "sideMenuOverlay" :"sideMenuOverlay sideMenuOverlayShow"}
                onClick = {hideSideDrawwer}
            />
            
            <section className = {NavClassname}>
                <nav>
                    <div className = "logoWrapper" onClick ={BackToHome}>
                        <img src={LogoFPJ} alt=""/>
                        <span> &nbsp;Komunitas Film Pendek Jakarta</span>
                    </div>
                    <div className="menuNavWrapper" onClick={showSideDrawwer}>
                           <MenuOutlined/>
                    </div>
                </nav>
            </section> 
        </Fragment>
    )
}




const childUpdateProfileMenu= [
    {
        Menuname:"Authetication",
        link: '/UpdateProfle_Auth'
    },
    {
        Menuname:"Update Profile Detail",
        link: ''
    },
    
    

    
   
]

export default SideDrawer
